<template>
  <div>
    <img v-if="avatar" :src="avatar" />

    <loading-overlay />
  </div>
</template>

<script>
import auth from "../../server/auth";
import LoadingOverlay from "../workspace/LoadingOverlay.vue";
import avatarServer from "../../server/avatar";

export default {
  name: "PatientOriginalAvatarView",
  components: { LoadingOverlay },
  data() {
    return {
      avatarId: this.$route.params.avatarId,
      avatar: null
    };
  },
  async beforeMount() {
    if (this.$route.params.token) {
      auth.token(this.$route.params.token);
    }
  },
  async mounted() {
    try {
      this.avatar = await avatarServer.downloadUrl(this.avatarId);
    } catch {
      this.avatar = require(`../../assets/avatar-example.png`);
    }
  }
};
</script>
